<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="预采购单">
      <template v-if="hasPermission('采购-预采购单-新增')">
        <el-button
          size="small"
          icon="el-icon-plus"
          type="primary"
          @click="newlyAdded"
          >新增预采购单</el-button
        >
      </template>
    </pageTitle>
    <basicList
      :config="basicListconfig"
      @search="searchEvent"
      @sortChange="sortChange"
    >
      <template v-slot:operation="row">
        <div style="display: flex; align-items: center">
          <template v-if="row.row.status == 0 || row.row.status == 4">
            <div
              class="button button_modify"
              @click="generatePurchaseOrder(row.row)"
            >
              <i class="iconfont icon-xunjia"></i> 采购
            </div>
          </template>
          <el-popover
            :visible-arrow="false"
            placement="bottom"
            width="80"
            trigger="click"
          >
            <ul class="moreOperations">
              <li
                v-if="hasPermission('采购-预采购单-编辑')"
                @click="editButton(row.row)"
              >
                <i class="iconfont icon-bianji"></i> 编辑
              </li>
              <li v-else @click="preview(row.row)">
                <i class="iconfont icon-yulanmoban"></i> 查看
              </li>
              <li
                v-if="row.row.payed_money == 0 && row.row.status != 1"
                @click="cancelOrder(row.row)"
              >
                <i class="iconfont icon-quxiao"></i> 取消
              </li>
              <li v-if="row.row.status == 0" @click="generateInquiry(row.row)">
                <i class="iconfont icon-xunjia"></i> 询价
              </li>

              <li v-if="row.row.status == 1" @click="deleteRows(row.row)">
                <i class="iconfont icon-shanchu"></i> 删除
              </li>

              <!-- <li><img src="../../assets/images/icon_print.png" />打印</li>
              <li>
                <img
                  src="../../assets/images/icon_settlementModification.png"
                />结账修改
              </li> -->
            </ul>
            <div slot="reference" class="button button_more">
              <img src="../../assets/images/icon_more.png" />
            </div>
          </el-popover>
        </div>
      </template>
      <template v-slot:status="row">
        <div>
          <div v-if="row.row.status == 4" class="warnlinqi">部分到货</div>
          <div v-else class="safe">
            {{
              row.row.status == 0
                ? "正常"
                : row.row.status == 1
                ? "取消"
                : "到货"
            }}
          </div>
        </div>
      </template>
    </basicList>

    <formWindow
      :dialogParams="dialogParams"
      @close="closeThePopUpWindow"
    ></formWindow>
    <inquirySheet
      :dialogParams="inquirySheetParams"
      @close="closegenerateInquiry"
    ></inquirySheet>
    <purchaseOrderForm
      :dialogParams="generateProcurementParams"
      @close="closeProcure"
    ></purchaseOrderForm>
    <confirmForm
      :dialogParams="confirmParams"
      @close="closeconfirmform"
      @showform="showform"
    >
    </confirmForm>
    <previewComponents
      @close="closeView"
      :acceptedParameters="previewParams"
    ></previewComponents>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  preOrderBuyGetList,
  preOrderBuyDel,
  preOrderBuyGetOne,
  preOrderBuyLock,
} from "@/api/purchasing";
import {
  getshoplist,
  supplierGetList,
  userPermissionShopGetList,
  userPermissionSupplierGetList,
} from "@/api/basicConfiguration";
import { getRoles } from "@/utils";
// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "prePurchaseOrder",
  components: {
    formWindow: () => import("./formWindow.vue"),
    inquirySheet: () => import("./inquirySheet.vue"),
    purchaseOrderForm: () => import("../purchaseOrder/formWindow.vue"),
    previewComponents: () => import("@/components/previewComponents"),
    confirmForm: () => import("./confirmForm.vue"),
  },
  data() {
    return {
      compId: null,
      userId: null,
      roleId: null,
      shopIds: [], // 权限管理中允许用户使用的店铺，高级角色看所有店铺
      previewParams: {
        key: new Date().getTime(),
        visible: false,
        type: "purchaseOrder",
        code: "",
        viewObj: [],
      },
      // 弹窗参数
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      inquirySheetParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      generateProcurementParams: {
        key: new Date().getTime(),
        visible: false,
        type: "generatePurchaseOrder",
      },
      confirmParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      // 列表组件参数
      basicListconfig: {
        loading: false,
        operationWidth: 140,
        search: [
          {
            label: "门店",
            type: "select",
            options: [],
            key: "shop_id",
            value: "",
          },
          {
            label: "供应商",
            type: "select",
            options: [],
            key: "supplier_id",
          },
          {
            label: "状态",
            type: "select",
            options: [
              {
                label: "正常",
                value: 0,
              },
              {
                label: "取消",
                value: 1,
              },
              {
                label: "到货",
                value: 3,
              },
              {
                label: "部分到货",
                value: 4,
              },
            ],
            key: "status",
            width: 100,
          },
          // {
          //   label: "编号",
          //   type: "inputNumber",
          //   key: "id",
          //   width: 100,
          // },
          {
            label: "单号",
            type: "input",
            key: "form_sn",
          },
          {
            label: "创建时间",
            type: "daterange",
            key: "create_time",
          },
        ],
        data: [],
        column: [
          {
            label: "编号",
            prop: "id",
            width: 100,
            sortable: true,
          },
          {
            label: "门店",
            prop: "shop_name",
            width: 120,
          },

          {
            label: "供应商",
            prop: "supplier_name",
            width: 180,
          },
          {
            label: "数量",
            prop: "num",
            sortable: true,
            width: 80,
          },
          {
            label: "金额",
            prop: "total_money",
            width: 150,
            isMoney: true,
            sortable: true,
          },
          {
            label: "预付金额",
            prop: "payed_money",
            width: 150,
            sortable: true,
            isMoney: true,
          },
          {
            label: "创建时间",
            prop: "create_time",
            sortable: true,
            width: 200,
          },
          {
            label: "状态",
            prop: "status",
            filter: "documentStatus",
            slot: true,
            width: 100,
          },
          {
            label: "操作人",
            prop: "user_name",
            width: 100,
          },
          {
            label: "预采购单号",
            prop: "form_sn",
            width: 240,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    // 初始化列表内容
    // this.getlist();
    this.obtainDataSource().then(() => {
      this.basicListconfig.searchParameters.shop_id = JSON.parse(
        getRoles()
      ).shop_id;
      this.getlist(); // 先拿基础数据，在拉记录
    });
  },
  computed: {
    ...mapGetters(["hasPermission", "getPermissionId"]),
  },
  methods: {
    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getlist();
    },
    closeView() {
      this.previewParams.key = new Date().getTime();
      this.previewParams.visible = false;
    },
    // 查看事件
    preview(row) {
      this.previewParams.code = row.form_sn;
      preOrderBuyGetOne({ form_sn: row.form_sn }).then((res) => {
        if (res.code == 1) {
          let payData = res.$pay_list.map((item) => {
            item.pay_price = this.$money(item.pay_price);
            return item;
          });
          let data = res.$order_list.map((item) => {
            item.name =
              item.item_info.name +
              "(1*" +
              item.item_info.in_package_num +
              ")(" +
              item.item_info.item_number +
              ")";
            item.price_distribution = this.$money(item.price_distribution);
            item.need_item_stock_single = item.single_num;
            item.need_item_stock_package = item.package_num;
            item.total_money = (
              Number(item.price_distribution) *
              (Number(item.need_item_stock_single) +
                Number(item.need_item_stock_package) *
                  Number(item.in_package_num))
            ).toFixed(2);
            item.price_oneBox = (
              Number(item.price_distribution) * Number(item.in_package_num)
            ).toFixed(2);
            item.need_item_stock_total = (
              Number(item.need_item_stock_single) +
              Number(item.need_item_stock_package) * Number(item.in_package_num)
            ).toFixed(2);
            item.algorithm =
              item.price_distribution +
              "*" +
              "(" +
              item.need_item_stock_single +
              "+" +
              item.need_item_stock_package +
              "*" +
              item.in_package_num +
              ") = " +
              item.total_money;
            return item;
          });
          this.previewParams.viewObj = [
            {
              title: "",
              type: "object",
              value: [
                {
                  label: "采购门店",
                  value: res.order_info.shop_name,
                },
                {
                  label: "供应商",
                  value: res.order_info.supplier_name,
                },
                {
                  label: "配送方式",
                  value: res.order_info.customer_name,
                },
                {
                  label: "制单人",
                  value: res.order_info.user_name,
                },
                {
                  label: "备注",
                  value: res.order_info.remark,
                },
              ],
            },
            {
              title: "采购明细",
              type: "array",
              value: data,
              column: [
                {
                  label: "商品名称",
                  prop: "name",
                },
                {
                  label: "单价",
                  prop: "price_distribution",
                  align: "center",
                  // children: [
                  //   {
                  //     label: "散",
                  //     prop: "price_distribution",
                  //     width: 100,
                  //     align: "center",
                  //   },
                  //   {
                  //     label: "箱",
                  //     prop: "price_oneBox",
                  //     width: 100,
                  //     align: "center",
                  //   },
                  // ],
                },
                {
                  label: "采购数量",
                  prop: "need_item_stock_total",
                  align: "center",
                  // children: [
                  //   {
                  //     label: "散",
                  //     prop: "need_item_stock_single",
                  //     width: 100,
                  //     align: "center",
                  //   },
                  //   {
                  //     label: "箱",
                  //     prop: "need_item_stock_package",
                  //     width: 100,
                  //     align: "center",
                  //   },
                  //   {
                  //     label: "总",
                  //     prop: "need_item_stock_total",
                  //     width: 100,
                  //     align: "center",
                  //   },
                  // ],
                },
                {
                  label: "小计",
                  prop: "total_money",
                  width: 100,
                },
                // {
                //   label: "成本采购",
                //   children: [
                //     {
                //       label: "近期价",
                //       prop: "need_item_stock_single",
                //       width: 100,
                //       align: "center",
                //     },
                //     {
                //       label: "成本价",
                //       prop: "need_item_stock_package",
                //       width: 100,
                //       align: "center",
                //     },
                //   ],
                // },
                // {
                //   label: "算法",
                //   prop: "algorithm",
                //   width: 200,
                // },
              ],
            },
            {
              title: "",
              type: "object",
              value: [
                {
                  label: "订单金额",
                  value: this.$money(res.order_info.item_money),
                },
              ],
            },
            {
              title: "付款信息",
              type: "array",
              value: payData,
              column: [
                {
                  label: "付款账户",
                  prop: "account_name",
                },
                {
                  label: "付款金额",
                  prop: "pay_price",
                },
              ],
            },
            {
              title: "",
              type: "object",
              value: [
                {
                  label: "预付金额",
                  value: this.$money(res.order_info.payed_money),
                },
              ],
            },
          ];
          this.previewParams.key = new Date().getTime();
          this.previewParams.visible = true;
        } else {
          this.$message.error("获取详情失败");
        }
      });
    },
    generatePurchaseOrder(row) {
      this.confirmParams.visible = true;
      this.confirmParams.key = new Date().getTime();
      this.confirmParams.id = row.form_sn;
      //this.generateProcurementParams.visible = true;
      this.generateProcurementParams.key = new Date().getTime();
      this.generateProcurementParams.form_sn = row.form_sn;
    },
    showform() {
      this.generateProcurementParams.visible = true;
    },
    closeProcure() {
      this.generateProcurementParams.visible = false;
      this.generateProcurementParams.key = new Date().getTime();
      this.getlist();
    },
    // 打印报价单
    generateInquiry(row) {
      this.inquirySheetParams.key = new Date().getTime();
      this.inquirySheetParams.visible = true;
      this.inquirySheetParams.id = row.form_sn;
      this.inquirySheetParams.supplierId = row.supplier_id;
    },
    cancelOrder(row) {
      this.$confirm("撤回当前订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        preOrderBuyLock({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("取消成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg || "取消失败！");
          }
        });
      });
    },
    // 删除方法
    deleteRows(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        preOrderBuyDel({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 关闭弹窗
    closeThePopUpWindow() {
      this.dialogParams.visible = false;
      this.dialogParams.key = new Date().getTime();
      this.getlist();
    },
    //关闭弹窗
    closeconfirmform() {
      this.confirmParams.visible = false;
      this.confirmParams.key = new Date().getTime();
    },
    // 关闭弹窗
    closegenerateInquiry() {
      this.inquirySheetParams.visible = false;
      this.inquirySheetParams.key = new Date().getTime();
    },
    // 编辑弹窗
    editButton(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.form_sn;
    },
    // 新增事件
    newlyAdded() {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = "";
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          if (Array.isArray(data[key])) {
            if (data[key].length == 0) {
              delete this.basicListconfig.searchParameters.begin_time;
              delete this.basicListconfig.searchParameters.end_time;
            } else {
              this.basicListconfig.searchParameters.begin_time = data[key][0];
              this.basicListconfig.searchParameters.end_time = data[key][1];
            }
          }
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.search.map((item) => {
        if (item.key == "shop_id") {
          item.value = this.basicListconfig.searchParameters.shop_id;
        }
        return item;
      });
      this.basicListconfig.loading = true;

      // 有用户门店权限的，查看只能看指定门店记录
      // 用户选中店铺时，按所选店铺查看; 未选时，按用户权限所有店面查询
      if (!this.basicListconfig.searchParameters["shop_id"]) {
        if (this.shopIds.length != 0) {
          this.basicListconfig.searchParameters["shop_id"] =
            this.shopIds.join(", ");
        }
      }
      preOrderBuyGetList(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data.map((item) => {
            item.supplier_name =
              item.supplier_id +
              "-" +
              item.supplier_name +
              "(" +
              item.supplier_nickname +
              ")";
            return item;
          });
          this.basicListconfig.total = res.count;
        } else if (res.code == 0) {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    // 获取门店\供应商\资金账户 受权限控制
    getSupplier() {
      if (this.roleId == 4) {
        return userPermissionSupplierGetList({
          limit: 10000,
          status: 0,
          comp_id: this.compId,
        }).then((res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "supplier_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.id + "-" + item.nick_name,
                    value: item.id,
                  };
                });
              }
            });
          } else if (res.code == 0) {
            this.$message.error(res.data.msg || "获取供应商数据源失败！");
          }
        });
      } else {
        return supplierGetList({
          limit: 10000,
          status: 0,
          comp_id: this.compId,
        }).then((res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "supplier_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.id + "-" + item.nick_name,
                    value: item.id,
                  };
                });
              }
            });
          } else if (res.code == 0) {
            this.$message.error(res.data.msg || "获取供应商数据源失败！");
          }
        });
      }
    },
    getShops() {
      if (this.roleId == 4) {
        return userPermissionShopGetList({
          comp_id: this.compId,
          user_id: this.userId,
          permission_id: this.getPermissionId("采购-预采购单-查看"),
        }).then((res) => {
          if (res.code == 1) {
            this.shopIds = res.data.map((item) => item.id);
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: Number(item.id),
                  };
                });
                item.value = JSON.parse(getRoles()).shop_id;
              }
            });
          } else if (res.code == 0) {
            this.$message.error(res.data.msg || "获取门店数据源失败！");
          }
        });

        // 高级别所看门店不受控制
      } else {
        return getshoplist({
          limit: 10000,
          status: 0,
          comp_id: this.compId,
        }).then((res) => {
          if (res.code == 1) {
            this.shopIds = res.data.map((item) => item.id);
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: Number(item.id),
                  };
                });
              }
            });
          } else if (res.code == 0) {
            this.$message.error(res.data.msg || "获取门店数据源失败！");
          }
        });
      }
    },

    // 获取基础数据，获取完后才能拿列表
    obtainDataSource() {
      return Promise.all([this.getShops(), this.getSupplier()]);
    },
  },
};
</script>

<style>
.warn,
.dangerous,
.safe {
  margin-right: 5px; /* 右边距 */
}

/* 小于或等于10天时的警告样式 */
.warnlinqi {
  color: #ff0000 !important; /* 红色文字 */
}

/* 负数时的警告样式 */
.dangerous {
  color: red; /* 红色文字 */
  font-weight: bold; /* 字体加粗 */
}

.safe {
  color: green;
}
</style>



// WEBPACK FOOTER //
// src/views/prePurchaseOrder/index.vue